import type { QaChecklistBodyLabel } from "@remi/corrections/qa-assessment";
import { type ProjectCategory, ProjectCategoryDisplayNames } from "@remi/enums/project-category";

export type EnumsStrings = {
  projectCategory: {
    [Category in ProjectCategory]: string;
  };
  qaChecklistBody: {
    [Label in QaChecklistBodyLabel]: string;
  };
};

export const enumsEn: EnumsStrings = {
  projectCategory: ProjectCategoryDisplayNames,
  qaChecklistBody: {
    SHINGLE: "Shingle",
    TILE: "Tile",
    LOW_SLOPE: "Low-slope",
    SOLAR_DR: "Solar D&R",
    SIDING: "Siding",
    GUTTERS: "Gutters",
  },
};

export const enumsEs: EnumsStrings = {
  projectCategory: {
    FULL_ROOF: "Techo entero",
    PARTIAL_ROOF: "Techo parcial",
    STRUCTURAL: "Estructural",
    VENT_WORK: "Ventilación",
    MISC: "Misceláneo",
    RFR: "RFR",
    REINSTALL: "Instalar",
    REMOVAL: "Remover",
    BID: "Licitación",
    BACKFILL: "Reinstalar tejas",
    CORRECTIONS: "Correcciones",
    ASSESSMENT: "Evaluación",
    GUTTERS: "Canales",
    SIDING: "Siding",
    SITE_VISIT: "Revisión del sitio",
    SOLAR_REDESIGN: "Rediseño del sistema solar",
    ESTIMATE_ONLY: "Estimación",
    QA: "Control de calidad",
  },
  qaChecklistBody: {
    SHINGLE: "Tejas asfálticas",
    TILE: "Teja",
    LOW_SLOPE: "Techo plano",
    SOLAR_DR: "Paneles solares",
    SIDING: "Siding",
    GUTTERS: "Canales",
  },
};
